import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('commerciali');
export const actions = helper.createActions('commerciali', actionTypes);